export const CardStates = {
  InformOnline: 'informOnline',
  Category: 'category',
};

export const IconMappings = {
  [CardStates.InformOnline]: {
    true: 'fa-globe',
  },
  [CardStates.Category]: {
    Einnahmen: 'fa-money',
    'Haus/Wohnung': 'fa-home',
    Versicherungen: 'fa-file-text',
    Kommunikation: 'fa-comments',
    Mobilität: 'fa-car',
    Institutionen: 'fa-university',
    Handel: 'fa-shopping-cart',
  },
};
